module.exports = __webpack_public_path__ + "img/3f_r_pepper@2x.1b979be9.png";